import { useZero } from "@rocicorp/zero/react";
import { useCallback, useSyncExternalStore } from "react";
import { sharedMutators } from "../../shared/mutators";

const KEY = "sidebarCollapsed";

const listeners = new Set<() => void>();

function notify() {
  for (const listener of listeners) listener();
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  const onStorage = (e: StorageEvent) => {
    if (e.key === KEY) callback();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(callback);
    window.removeEventListener("storage", onStorage);
  };
}

function getSnapshot() {
  return localStorage.getItem(KEY) === "on";
}

function setCollapsed(next: boolean) {
  if (next) {
    localStorage.setItem(KEY, "on");
  } else {
    localStorage.removeItem(KEY);
  }
  notify();
}

export function useSidebarCollapsed(): [boolean, (next: boolean) => void] {
  const collapsed = useSyncExternalStore(subscribe, getSnapshot, () => false);
  const z = useZero();
  const setter = useCallback(
    (next: boolean) => {
      setCollapsed(next);
      z.mutate(
        sharedMutators.setSidebarCollapsed({
          surface: "sidebar",
          collapsed: next,
        })
      );
    },
    [z]
  );
  return [collapsed, setter];
}
